<div class="ac-modal">
	<dz-toast-alert class="toast-notif" *ngIf="toastNotification.length" [notifications]="toastNotification" position="'sticky'"></dz-toast-alert>
	<div class="header">
		<h3 class="text-align-center" dcrHTMLKey="PARTNER_PORTFOLIOS_STEPS_TITLE">Import Client Accounts</h3>
		<div class="partner-stepper-header dz-text-14-bold">
			<ac-wizard-steps [activeStepIndex]="stepIndex" [stepsLabels]="wizardStepLabels"></ac-wizard-steps>
		</div>
	</div>
	<ac-wizard [(stepIndex)]="stepIndex" [showHeader]="false" [showFooterActions]="false" contentHeight="415px">
		<ac-wizard-step>
			<ipp-partner-selection [mode]="mode" [hidden]="showAcknowledgement"></ipp-partner-selection>
			<ng-container *ngIf="showAcknowledgement">
				<div *ngIf="!isSavingAcknowledgement">
					<dz-microaction icon="angle-left" (menuItemClick)="onPartnerAcknowledgementBack()">
						<span dcrHTMLKey="PARTNER_ACKNOWLEDGEMENT_BACK">Back to Platform Select</span>
					</dz-microaction>
					<div class="partner-acknowledgement-disclaimer-msg" [dcrHTMLKey]="'PARTNER_ACKNOWLEDGEMENT_DISCLAIMER_MSG_' + selectedPartner?.id"></div>
				</div>
				<div *ngIf="isSavingAcknowledgement" class="dz-flex dz-justify-content-center dz-align-items-center partner-loader">
					<dz-progress-spinner></dz-progress-spinner>
					<p class="margin-top-layout-2" dcrHTMLKey="PARTNER_ACKNOWLEDGEMENT_LOADER_MSG">Please wait while we store your acknowledgement</p>
				</div>
			</ng-container>
		</ac-wizard-step>
		<ac-wizard-step>
			<div *ngIf="isAuthInProgress" class="dz-flex dz-justify-content-center dz-align-items-center partner-loader">
				<dz-progress-spinner></dz-progress-spinner>
				<p class="margin-top-layout-2" dcrHTMLKey="PARTNER_LOGIN_MSG">Please login to the partner platform to proceed ahead</p>
			</div>
			<ipp-portfolio-selection *ngIf="!isAuthInProgress && stepIndex >= 1" [mode]="mode" (searchError)="handleSearchError($event)"></ipp-portfolio-selection>
		</ac-wizard-step>
		<ac-wizard-step>
			<div *ngIf="isFetchingData" class="dz-flex dz-justify-content-center dz-align-items-center partner-loader">
				<dz-progress-spinner></dz-progress-spinner>
				<p class="margin-top-layout-2 text-bold text-align-center" dcrHTMLKey="PARTNER_FETCH_ACCOUNT_DATA_HEADER">
					We're importing your portfolios from your third-party platform.
				</p>
				<p class="margin-top-layout-2 text-align-center" dcrHTMLKey="PARTNER_FETCH_ACCOUNT_DATA_DESCRIPTION">This can take a few seconds to complete.</p>
			</div>
			<div *ngIf="isImporting" class="dz-flex dz-justify-content-center dz-align-items-center partner-loader">
				<dz-progress-spinner></dz-progress-spinner>
				<p class="margin-top-layout-2 text-bold text-align-center" dcrHTMLKey="PARTNER_IMPORT_PORTFOLIOS_HEADER">
					We're importing your portfolios from your third-party platform.
				</p>
				<p class="margin-top-layout-2 text-align-center" dcrHTMLKey="PARTNER_IMPORT_PORTFOLIOS_DESCRIPTION">
					This can take a few seconds to complete. You will automatically proceed to 360&deg; Evaluator to analyze your portfolio(s).
				</p>
			</div>
			<ipp-portfolio-edit
				*ngIf="!isImporting && !isFetchingData && stepIndex === 2"
				[missingPortfolioDataIds]="missingPortfolioDataIds"
				(portfolioEditNotifications)="handlePortfolioEditNotifications($event)"
				(isFormValid)="onIsFormValid($event)"
			></ipp-portfolio-edit>
		</ac-wizard-step>
	</ac-wizard>
	<div class="footer actions clearfix">
		<button
			dz-button
			*ngIf="stepIndex > 0"
			[track-event]="'import-external-portfolio-popup:step' + (stepIndex + 1) + ':button:back'"
			(click)="onStepIndexChange(stepIndex - 1)"
			[disabled]="isImporting || isFetchingData"
			color="secondary"
			dcrHTMLKey="PARTNER_PORTFOLIOS_STEP_BACK"
		>
			Back
		</button>
		<button
			(click)="onStepIndexChange(stepIndex + 1)"
			*ngIf="stepIndex < wizardStepLabels.length - 1"
			dz-button
			class="pull-right"
			[disabled]="
				(stepIndex === 0 && !selectedPartner?.isSelected) ||
				(stepIndex === 0 && partnerAcknowledgementInfo[selectedPartner.id]?.isUserAcknowledgementRequired && isSavingAcknowledgement) ||
				(stepIndex === 1 && (isAuthInProgress || !selectedPortfolios.size))
			"
			[track-event]="'import-external-portfolio-popup:step' + (stepIndex + 1) + ':button:next'"
			[dcrHTMLKey]="showAcknowledgement ? 'PARTNER_PORTFOLIOS_ACKNOWLEDGEMENT_ACCEPT' : 'PARTNER_PORTFOLIOS_STEP_NEXT'"
		>
			Next
		</button>
		<button
			(click)="onPartnerAcknowledgementBack()"
			*ngIf="showAcknowledgement"
			color="secondary"
			dz-button
			[disabled]="isSavingAcknowledgement"
			class="pull-right margin-right-layout-2"
			[track-event]="'import-external-portfolio-popup:step' + (stepIndex + 1) + ':button:decline'"
			dcrHTMLKey="PARTNER_PORTFOLIOS_ACKNOWLEDGEMENT_DECLINE"
		>
			I Decline
		</button>
		<button
			(click)="onImportPortfolios()"
			*ngIf="stepIndex === wizardStepLabels.length - 1"
			dz-button
			class="pull-right"
			[disabled]="isImporting || isFetchingData || hasInvalidPortfolios || portfolioNamesHaveErrors"
			[track-event]="'import-external-portfolio-popup:step' + (stepIndex + 1) + ':button:import'"
			dcrHTMLKey="PARTNER_PORTFOLIOS_FINAL_STEP_NAME"
		>
			Import
		</button>
	</div>
</div>
